module.exports = __webpack_public_path__ + "img/early-access.49b1a250.jpg";